import { Component, OnInit } from '@angular/core';
import { ExposedReadUserDetailsRes } from 'app/interfaces/responses/Exposed/exposedReadUserDetailsRes';
import { LsrauthService } from 'app/services/api/lsrauth/lsrauth.service';
import { USER_ROLES } from 'common/constants/user-role.constants';

@Component({
    selector: 'app-assists-overview',
    templateUrl: './assists-overview.component.html',
    styleUrls: ['./assists-overview.component.scss'],
})
export class AssistsOverviewComponent implements OnInit {
    userDetails: ExposedReadUserDetailsRes = null;

    userRoles = USER_ROLES;

    constructor(public lsrauthService: LsrauthService) {
        this.lsrauthService.userDetails.subscribe((userDetails) => (this.userDetails = userDetails));
    }

    ngOnInit(): void {}
}
